// src/components/ProtectedRoute.tsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Loader from "../components/reusable-loader/Loader";

interface ProtectedRouteProps {
  isAuthenticated: string | null;
  isAuthLoading?: boolean;
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  isAuthenticated,
  isAuthLoading = false,
  children,
}) => {
  const location = useLocation();

  const token =
    isAuthenticated && isAuthenticated.length
      ? isAuthenticated
      : localStorage.getItem("tobacco_access_token");

  if (isAuthLoading) {
    return <Loader />;
  }

  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
